export default "__VITE_ASSET__DX8Kp0pv__"